/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ModernInputs */

const cs_enum_modern = /** @type {(inputs: Enum_ModernInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderní`)
};

const en_enum_modern = /** @type {(inputs: Enum_ModernInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern`)
};

/**
* | output |
* | --- |
* | "Modern" |
*
* @param {Enum_ModernInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_modern = /** @type {((inputs?: Enum_ModernInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ModernInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_modern(inputs)
	return cs_enum_modern(inputs)
});